import { WINES_SERVICE } from "@/services/wines.service.js";

const state = {postWineOutput: false, getWinesOutput: {}, putWineOutput: false, getWineDetailsOutput: {}, deleteWineByIdOutput: false, getWineBySlugOutput: {}};

const actions = {
    //Service to create wines
    postWine({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postWineRequest');
        
        WINES_SERVICE.postWine(input)
            .then(
                output => {
                    commit('postWineSuccess', output);
                },
                error => {
                    commit('postWineFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get paginated wines
    getWines({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getWinesRequest');

        WINES_SERVICE.getWines(queryParams)
            .then(
                output => {
                    commit('getWinesSuccess', output);
                },
                error => {
                    commit('getWinesFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update wines
    putWine({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putWineRequest');

        WINES_SERVICE.putWine(input)
            .then(
                output => {
                    commit('putWineSuccess', output);
                },
                error => {
                    commit('putWineFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get wine details
    getWineDetails({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getWineDetailsRequest');

        WINES_SERVICE.getWineDetails(queryParams)
            .then(
                output => {
                    commit('getWineDetailsSuccess', output);
                },
                error => {
                    commit('getWineDetailsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to delete wines
    deleteWineById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteWineByIdRequest');

        WINES_SERVICE.deleteWineById(id)
            .then(
                output => {
                    commit('deleteWineByIdSuccess', output);
                },
                error => {
                    commit('deleteWineByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //postWine
    postWineRequest(state) {
        state.postWineOutput = null;
    },
    postWineSuccess(state, output) {
        state.postWineOutput = true;
    },
    postWineFailure(state) {
        state.postWineOutput = false;
    },

    //getWines
    getWinesRequest(state) {
    },
    getWinesSuccess(state, output) {
        state.getWinesOutput = output;
    },
    getWinesFailure(state) {
        state.getWinesOutput = false;
    },

    //putWine
    putWineRequest(state) {
        state.putWineOutput = null;
    },
    putWineSuccess(state, output) {
        state.putWineOutput = true;
    },
    putWineFailure(state) {
        state.putWineOutput = false;
    },

    //getWineDetails
    getWineDetailsRequest(state) {
    },
    getWineDetailsSuccess(state, output) {
        state.getWineDetailsOutput = output;
    },
    getWineDetailsFailure(state) {
        state.getWineDetailsOutput = false;
    },

    //deleteWineById
    deleteWineByIdRequest(state) {
        state.deleteWineByIdOutput = null;
    },
    deleteWineByIdSuccess(state, output) {
        state.deleteWineByIdOutput = true;
    },
    deleteWineByIdFailure(state) {
        state.deleteWineByIdOutput = false;
    },
};

export const wines = {
    namespaced: true,
    state,
    actions,
    mutations
};